// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_ssm_param_rmi_company_name": "/special-tools/feature/rmi-service-company",
    "aws_ssm_param_rmi_secret_name": "/special-tools/feature/rmi-service-password",
    "aws_ssm_param_rmi_user_name": "/special-tools/feature/rmi-service-username",
    "aws_ssm_param_rmi_type_id": "/special-tools/feature/rmi-service-type-id",
    "aws_data_exchange_bucket": "data-exchange-dsml-sandbox",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_graphqlEndpoint": "https://7hizlh6e4bg3navckhyhzo5uey.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "RumUserMonitoring": {
        "RumMonitorId": "bd367076-3ad3-4f12-ba58-c61fa033e253",
        "RumRegion": "eu-central-1",
        "RumTelemetries": "errors,http"
    },
    "aws_user_files_s3_bucket": "tecrmi-feature-image-generation-frontend",
    "aws_user_files_s3_bucket_region": "eu-central-1",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:95730443-069c-418e-8ad2-417396f87b1e",
    "aws_cognito_password_protection_settings": {
        "passwordPolicyCharacters": [],
        "passwordPolicyMinLength": 8
    },
    "cognito_start_image_generation_process_group": "StartImageGenerationProcess",
    "oauth": {
        "redirectSignOut": "http://localhost:3000/,https://feature-image-generation.d1dalb5kmxgzdl.amplifyapp.com/,https://feature-image-generation.sandbox.tm.ai.tecalliance.net/,https://sandbox.tm.ai.tecalliance.net/",
        "domain": "tecrmi-auth-feature-image-generation.auth.eu-central-1.amazoncognito.com",
        "responseType": "code",
        "redirectSignIn": "http://localhost:3000/,https://feature-image-generation.d1dalb5kmxgzdl.amplifyapp.com/,https://feature-image-generation.sandbox.tm.ai.tecalliance.net/,https://sandbox.tm.ai.tecalliance.net/",
        "scope": [
            "openid",
            "profile",
            "email",
            "aws.cognito.signin.user.admin"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "cognito_start_vectorization_process_group": "StartVectorizationProcess",
    "aws_user_pools_id": "eu-central-1_jO9ab6vgb",
    "aws_user_pools_web_client_id": "2j4838p0n6ta584vtgh4blfc3j",
    "aws_cognito_region": "eu-central-1",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_custom_provider": "TecRMIfeatureimaoAzureAD79C4BF2F",
    "aws_cognito_social_providers": [],
    "backend": {
        "region": "eu-north-1",
        "bucket_name": "tecrmi-manuals-feature"
    },
    "amplify_appid": "d1dalb5kmxgzdl",
    "aws_project_region": "eu-central-1",
    "vectorization_apigateway_url": "https://z7dh3xghg6.execute-api.eu-central-1.amazonaws.com/feature/",
    "vectorization_images_s3_bucket_name": "img-vectorization-feature-images"
};

export default awsmobile;
